import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Formik } from "formik";
import {
  Title,
  Text,
  Margin,
  Input,
  Button,
  Loading,
  ErrorMessage,
} from "~/components/elements";
import * as S from "./styles";
import { schema } from "./validation";
import { Creators as AuthenticationActions } from "~/store/modules/authentication/actions";
import isMobile from "~/hooks/isMobile";
import history from "~/routes/history";

export default function FormLogin({ participanteHash }) {
  const mobile = isMobile();
  const dispatch = useDispatch();
  const sending = useSelector((state) => state.authentication.auth.sending);
  const logged = useSelector((state) => state.authentication.auth.loginToken);
  const completeSignUp = useSelector(
    (state) => state.authentication.auth.user.cadastroCompleto
  );
  const errorMessage = useSelector(
    (state) => state.authentication.auth.errorMessage
  );
  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;
  const initialValues = {
    Email: "",
    Senha: "",
  };
  useEffect(() => {
    dispatch(AuthenticationActions.setAuthenticationMessage());
    if (logged) {
      history.push("/minha-conta");
    }
    return () => {
      dispatch(AuthenticationActions.setAuthenticationMessage());
    };
  }, [dispatch, logged, completeSignUp]);
  return (
    <S.FormHolder>
      <Margin mt={mobile ? 6 : 12} mb={mobile ? 1 : 2}>
        <Title as="1" levelDesktop="3" level="4" emphasis={false}>
          Acceso
        </Title>
      </Margin>
      <Margin mb={4}>
        <Text level={mobile ? "2" : "1"}>
          Inicia sesión con el correo electrónico y la contraseña registrados
        </Text>
      </Margin>
      <Margin mb={3}>
        <Formik
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(false);
            dispatch(
              AuthenticationActions.sendAuthentication({
                ...values,
                url: url,
                origin: origin,
              })
            );
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isValid,
            dirty,
          }) => (
            <S.FormLimiter onSubmit={handleSubmit}>
              <Margin mb={mobile ? 3 : 4}>
                <Input
                  label="Correo electrónico"
                  placeholder="Ingrese su correo electrónico registrado"
                  htmlFor="emailFieldFormLogin"
                  name="Email"
                  value={values.Email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  errors={errors.Email && touched.Email && errors.Email}
                  valid={!errors.Email && touched.Email && !errors.Email}
                  required
                />
              </Margin>
              <Margin mb={2}>
                <Input
                  label="Contraseña"
                  placeholder="Ingrese su contraseña registrada"
                  htmlFor="passwordFieldFormLogin"
                  name="Senha"
                  type="password"
                  showHidePassword={true}
                  value={values.Senha}
                  maxLength={12}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  valid={!errors.Senha && touched.Senha && !errors.Senha}
                  errors={errors.Senha && touched.Senha && errors.Senha}
                  required
                />
              </Margin>
              <Margin mb={4}>
                <S.ForgotLink>
                  <Link to="/esqueci-minha-senha" id="forgotLinkFormLogin">
                    Olvidé mi contraseña
                  </Link>
                </S.ForgotLink>
              </Margin>
              <S.ButtonHolder>
                <Button
                  className="animation-size"
                  color={!isValid || !dirty || sending ? "disabled" : "primary"}
                  type="submit"
                  disabled={!isValid || !dirty || sending}
                  id="sendButtonFormLogin"
                >
                  {sending ? <Loading button /> : "INICIAR SESIÓN"}
                </Button>
              </S.ButtonHolder>
            </S.FormLimiter>
          )}
        </Formik>
      </Margin>
      {errorMessage && !participanteHash && (
        <Margin mb={3}>
          <ErrorMessage inset>{errorMessage}</ErrorMessage>
        </Margin>
      )}
      <Margin mb={mobile ? 5 : 12}>
        <S.TextHolder>
          <Text level="1">
            ¿Aún no tienes una cuenta? <br className="mobileOnly" />
            <span onClick={() => history.push("/")} id="signupLinkFormLogin">
              REGISTRARSE
            </span>
          </Text>
        </S.TextHolder>
      </Margin>
    </S.FormHolder>
  );
}
